import { render, staticRenderFns } from "./CarrierInvoicesNew.vue?vue&type=template&id=30352440&"
import script from "./CarrierInvoicesNew.vue?vue&type=script&lang=js&"
export * from "./CarrierInvoicesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports